import { Action, getModule, Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import {
    ILoyaltySubscriptionType,
    ILoyaltySubscriptionTypeListItem,

} from '@/entity/loyalty/loyaltySubscription/loyaltySubscriptionType/LoyaltySubscriptionType.types';
import { PaginationRequestType } from '@/entity/common/pagination.types';
import { LoyaltySubscriptionTypeGeneralRequestType } from '@/form/loyalty/loyaltySubscriptionType/LoyaltySubscriptionTypeGeneral.types';
import { ResponseDataType } from '@/form/form.types';
import { prepareFormData } from '@/store/utils/formDataHelper';

@Module({
    namespaced: true,
    name: 'loyaltySubscriptionType',
    store,
    dynamic: true,
})
class LoyaltySubscriptionTypeModule extends VuexModule {
    loyaltySubscriptionTypes: ILoyaltySubscriptionType | null = null;
    loyaltySubscriptionType: ILoyaltySubscriptionTypeListItem | null = null;
    loyaltySubscriptionTypeLoaded = false;
    @MutationAction
    async fetchAll(
        data?: PaginationRequestType
    ): Promise<{ loyaltySubscriptionTypes: ILoyaltySubscriptionType; loyaltySubscriptionTypeLoaded: boolean }> {
        let loyaltySubscriptionTypeLoaded = false;
        const loyaltySubscriptionTypes = await store.$repository.loyaltySubscriptionType.fetchAll(
            prepareFormData(data)
        );

        if (loyaltySubscriptionTypes) {
            loyaltySubscriptionTypeLoaded = true;
        }
        return { loyaltySubscriptionTypes, loyaltySubscriptionTypeLoaded };
    }

    @Action({ rawError: true })
    async fetchSubscriptionTypeById(data: {filter: { id: number }}): Promise<ResponseDataType> {
        return await store.$repository.loyaltySubscriptionType.fetchSubscriptionTypeById(data);
    }
    @Action({ rawError: true })
    async create(data: LoyaltySubscriptionTypeGeneralRequestType): Promise<ResponseDataType> {
        return await store.$repository.loyaltySubscriptionType.create(data);
        //return resp;
    }
    @Action({ rawError: true })
    async update(data: LoyaltySubscriptionTypeGeneralRequestType): Promise<ResponseDataType> {
        return await store.$repository.loyaltySubscriptionType.update(data);
    }

    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ loyaltySubscriptionType: ILoyaltySubscriptionTypeListItem  ; loyaltySubscriptionTypeLoaded: boolean }> {
        let loyaltySubscriptionTypeLoaded = false;
        const loyaltySubscriptionType = await store.$repository.loyaltySubscriptionType.fetchData(data);
        if (loyaltySubscriptionType) {
            loyaltySubscriptionTypeLoaded = true;
        }
        return { loyaltySubscriptionType, loyaltySubscriptionTypeLoaded};
    }
    // @Action({rawError: true})
    // async create(data: LoyaltySubscriptionTypeGeneralRequestType): Promise<ResponseDataType> {
    //     const resp = await store.$repository.counterparties.create(data);
    //     return resp;
    // }
    // @Action({rawError: true})
    // async update(data: LoyaltySubscriptionTypeGeneralRequestType): Promise<ResponseDataType> {
    //     const resp = await store.$repository.counterparties.update(data);
    //     return resp;
    // }
    // @Action({rawError: true})
    // async delete(data: {id: number}): Promise<ResponseDataType> {
    //     const resp = await store.$repository.counterparties.delete(data);
    //     return resp;
    // }
}

export const LoyaltySubscriptionTypeStore = getModule(LoyaltySubscriptionTypeModule);
